import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ApplyService } from 'src/app/services/apply.service';

@Component({
  selector: 'app-application-list',
  templateUrl: './application-list.component.html',
  styleUrls: ['./application-list.component.scss']
})
export class AgentApplicationListComponent implements OnInit {

  constructor(private route: ActivatedRoute, private spinner: SpinnerService, private applyService: ApplyService) { }

  applies: any[];
  total: number;
  limit = 50;
  criteria: any = {
    Statuses: [],
    Scores: [],
    Sort: 0
  };

  async ngOnInit() {
    await new Promise<void>(resolve => {
      this.route.params.subscribe(async params => {
        this.criteria.JobId = params['id'];
        await this.load();
        resolve();
      });
    });
  }

  async toggleStatus(status: number) {
    const i = this.criteria.Statuses.indexOf(status);
    if (i > -1) {
      this.criteria.Statuses.splice(i, 1);
    } else {
      this.criteria.Statuses.push(status);
    }

    await this.load();
  }

  async toggleScore(score: number) {
    const i = this.criteria.Scores.indexOf(score);
    if (i > -1) {
      this.criteria.Scores.splice(i, 1);
    } else {
      this.criteria.Scores.push(score);
    }

    await this.load();
  }

  async load(page: { from: number, limit: number } = { from: 0, limit: this.limit }) {
    this.spinner.show();
    const result = await this.applyService.owner(this.criteria, page.from, page.limit);
    this.applies = result.applies;
    this.total = result.total;
    this.spinner.hide();
  }

  async update(apply: any) {
    this.spinner.show();
    Object.assign(apply, await this.applyService.ownerUpdate(apply));
    this.spinner.hide();
  }
}
